var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lds-ring",style:(`--loading-width: ${_vm.width}px; --loading-color: ${_vm.color}`)},[_c('div'),_c('div'),_c('div'),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }